module.exports = __webpack_public_path__ + "img/zipper.a4a1f56b.png";